import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AuthService } from './auth.service';

export function authHeaderInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
	const authService = inject(AuthService);
	return authService.getAccessToken().pipe(
		mergeMap(accessToken => {
			const authReq = req.clone({
				headers: req.headers.set('Authorization', `Bearer ${accessToken}`),
			});

			return next(authReq);
		})
	);
}
